import { apiInstance } from "@/utils/ApiUtil";
const baseURL = "/admin/payment";

const getAll = async (req) => {
    try {
        const response = await apiInstance.get(baseURL + "/all", {
            params: {
                search: req.search,
                method: req.method,
                status: req.status,
                type: req.type,
                sort: req.sort,
                page: req.page,
                limit: req.limit,
            }
        });
        return response.data.success ? response.data : [];
    } catch (error) {
        return [];
    }
};

const getById = async (id) => {
    try {
        const response = await apiInstance.get(baseURL + `/${id}`);
        return response.data.success ? response.data.item : null;
    } catch (error) {
        return null;
    }
};

const getStats = async (req) => {
    try {
        const response = await apiInstance.get(baseURL + "/stats", {
            params: {
                method: req.method,
                type: req.type,
                status: req.status,
            }
        });
        return response.data.success ? response.data : false;
    } catch (error) {
        return false;
    }
};

const updateStatus = async (id, status) => {
    try {
        const response = await apiInstance.put(baseURL + `/status/${id}`, { status });
        return response.data.success ? response.data : false;
    } catch (error) {
        return false;
    }
};

const AdminPaymentService = {
    getAll,
    getStats,
    getById,
    updateStatus
}

export default AdminPaymentService;